<template>
  <div class="padding-md">
    <el-row>
      <el-col :span="24">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="商品名称">
            <el-input v-model="searchForm.name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="loadData">查询</el-button>
            <el-button type="success" @click="showDialog()">添加</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="24" v-if="loadedData">
        <el-table
          :data="loadedData.rows"
          v-loading="loading"
          :stripe="true"
          border
          style="width: 100%">
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form label-position="left" inline class="product-table-expand">
                <el-form-item label="商品描述">
                  <span>{{ props.row.description }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column prop="id" label="ID" min-width="60" max-width="100"></el-table-column>
          <el-table-column prop="name" label="名称" min-width="140"></el-table-column>
          <el-table-column prop="icon" label="icon" min-width="80"></el-table-column>
          <el-table-column prop="hotStatus" label="商品状态" min-width="100">
            <template slot-scope="scope">
              <span>{{findProductStatus(scope.row.hotStatus)}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="category" label="商品类别">
            <template slot-scope="scope">
              <span>{{ findProductType(scope.row.category) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="sellType" label="出售货币类型" min-width="100">
            <template slot-scope="scope">
              <span>{{findSellType(scope.row.sellType)}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="价格：元/钻石数" min-width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.price | currency }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="sellCount" label="数量" min-width="80"></el-table-column>
          <el-table-column prop="timeLimit" label="限时道具" min-width="80">
            <template slot-scope="scope">
              <span>{{ formatTimeLimit(scope.row.timeLimit)}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="itemId" label="道具编号" min-width="80"></el-table-column>

          <el-table-column fixed="right" label="操作" min-width="160">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="showDialog(scope.row)">修改</el-button>
              <el-button type="danger" size="mini" @click="deleteProduct(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="padding-vertical-md"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="loadedData.currentPage"
          :page-sizes="pageSizes"
          :page-size="loadedData.pageSize"
          :page-count="loadedData.totalPages"
          layout="total, sizes, prev, pager, next, jumper"
          :total="loadedData.count">
        </el-pagination>
      </el-col>
    </el-row>
    <el-dialog el-dialog :title="title" :visible.sync="showEditorDialog" class="update"
               :before-close="handleBeforeCloseDialog">
      <el-form :model="formData" ref="formData" label-width="80px" :rules="formRules">
        <el-row>
          <el-col :md="12">
            <el-form-item label="商品编号" prop="id">
              <el-input type="text" v-model.trim="formData.id"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :md="12">
            <el-form-item label="商品名称" prop="name">
              <el-input type="text" v-model.trim="formData.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :md="12">
            <el-form-item label="商品icon" prop="icon">
              <el-input type="text" v-model.trim="formData.icon"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :md="12">
            <el-form-item label="商品类别" prop="category">
              <el-select @change="dropDownEvent" v-model="formData.category" placeholder="请选择">
                <el-option
                  v-for="item in productType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="商品状态">
              <!--<el-input v-model="formData.hotStatus"></el-input>-->
              <el-select v-model="formData.hotStatus" placeholder="请选择">
                <el-option
                  v-for="item in productStatus"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="出售货币">
              <el-select v-model="formData.sellType" placeholder="请选择" :disabled="true">
                <el-option
                  v-for="item in sellType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :md="18">
            <el-form-item class="form-item__full-width" label="价格：" prop="price">
              <el-input-number :controls="false" v-model="formData.price" :min="0" class="priceInput"></el-input-number>
              <label style="display: inline-block;padding-left:8px;">备注：分/钻石</label>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :md="12">
            <el-form-item class="form-item__full-width" label="数量" prop="sellCount">
              <el-input-number :controls="false" v-model="formData.sellCount" :min="0"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="商品描述">
              <el-input v-model="formData.description"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="限时道具">
              <el-input v-model="formData.timeLimit"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :md="12">
            <el-form-item label="道具ID" prop="itemId">
              <el-input type="text" v-model.trim="formData.itemId"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <el-button type="primary" native-type="submit" @click.native.prevent="handleSubmit('formData')">保存</el-button>
          <el-button @click="closeDialog">返回</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import {
    getProducts,
    deleteProduct,
    saveProduct,
    updateProduct
  } from '@/api/products';
  import {validateInteger} from '@/utils/validate';
  import configs from '@/configs';
  import {getToken} from '@/utils/auth';
  import constant from '@/utils/constant';
  import _find_ from 'lodash/find';

  function defaultForm () {
    return {
      id: 0,
      hotStatus: 0,
      name: null,
      category: constant.PRODUCT_CATEGORY[0].value,
      description: null,
      price: 0,
      sellCount: 0,
      sellType: 0,
      timeLimit: '',
      icon: '',
      itemId: 0
    };
  }

  export default {
    name: 'products',
    data () {
      const validatePrice = function (rule, value, callback) {
        if (!(parseInt(value) && parseInt(value) > 0)) {
          callback(new Error('请输入商品价格且大于1'));
        } else if (!validateInteger(value)) {
          callback(new Error('请输入一个整数'));
        } else {
          callback();
        }
      };
      const validateCount = function (rule, value, callback) {
        if (!(parseInt(value) && parseInt(value) > 0)) {
          callback(new Error('请输入商品数量且大于1'));
        } else if (!validateInteger(value)) {
          callback(new Error('请输入一个整数'));
        } else {
          callback();
        }
      };
      const validateGift = function (rule, value, callback) {
        if (!validateInteger(value)) {
          callback(new Error('请输入一个整数'));
        } else {
          callback();
        }
      };

      return {
        action: `${configs.API_SERVER}/api/admin/upload/icon`,
        headers: {
          'X-Access-Token': getToken()
        },
        isAdd: false,
        loading: true,
        loadedData: null,
        title: null,
        showEditorDialog: false,
        imgNotShow: true,
        apps: [],
        productType: constant.PRODUCT_CATEGORY,
        productStatus: constant.PRODUCT_STATUS,
        sellType: constant.SELL_TYPE,
        searchForm: {
          name: null
        },
        formData: defaultForm(),
        formRules: {
          id: [{required: true, trigger: 'blur', message: '请输入商品编号'}],
          name: [{required: true, trigger: 'blur', message: '请输入商品名称'}],
          icon: [{required: true, trigger: 'blur', message: '请输入商品icon'}],
          price: [
            {required: true, validator: validatePrice, trigger: 'blur'},
          ],
          sellCount: [
            {required: true, validator: validateCount, trigger: 'blur'},
          ],
          itemId: [
            {required: true, trigger: 'blur', message: '请输入道具编号,限时道具填写零'},
          ],
          gift: [
            {required: true, validator: validateGift, trigger: 'blur'},
          ],
        },
        pageSizes: constant.PAGINATION.pageSizes
      };
    },
    /**
     * 初始化钩子
     */
    created () {
      this.loadData();
    },
    methods: {
      _find_,
      findAppName (index) {
        const app = _find_(this.apps, {appIndex: index});
        return app && app.appName;
      },

      /**
       * 商品类型变化 关联出售货币类型
       */
      dropDownEvent (value) {
        if (value <= 1 || value === 10) {
          this.formData.sellType = constant.SELL_TYPE[0].value;
        } else{
          this.formData.sellType = constant.SELL_TYPE[1].value;
        }
      },

      /**
       *加载数据
       */
      loadData (pager = {}) {
        pager.page = pager.page || 1;
        pager.pageSize = pager.pageSize || this.pageSizes[0];

        this.loading = true;
        getProducts({
          ...(this.searchForm),
          ...pager
        }).then(result => {
          this.loading = false;
          this.loadedData = result;
        }).catch(() => {
          this.loading = false;
        });
      },
      handleSizeChange (val) {
        this.loadData({
          page: this.loadedData && this.loadedData.currentPage,
          pageSize: val
        });
      },
      handleCurrentChange (val) {
        this.loadData({
          page: val
        });
      },

      /**
       * 打开添加商品面板
       */
      showDialog (obj) {
        this.showEditorDialog = true;
        if (!obj) {
          this.title = '添加商品';
          this.formData = defaultForm();
          this.isAdd = true;
          if (this.apps && this.apps[0]) {
            this.formData.appIndex = this.apps[0].appIndex;
          }

        } else {
          this.isAdd = false;
          this.title = '修改商品信息';
          this.formData = {...obj};
        }
      },

      clearForm () {
        this.$refs['formData'].resetFields();
      },

      handleBeforeCloseDialog (done) {
        this.clearForm();
        done();
      },

      closeDialog () {
        this.clearForm();
        this.showEditorDialog = false;
      },
      handleSubmit (name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            this.saveProduct();
          } else {
            this.$message.error('提交失败');
            return false;
          }
        });
      },

      /**
       * 保存商品信息
       */
      saveProduct () {
        const loading = this.$loading();
        if (!this.isAdd) {
          updateProduct(this.formData).then(result => {
            this.closeDialog();
            loading.close();
            if (result) {
              this.$message({
                message: '修改成功',
                type: 'success'
              });
              this.loadData();
            }
          }).catch(() => loading.close());
        } else {
          saveProduct(this.formData).then(() => {
            this.closeDialog();
            loading.close();
            this.$message({
              message: '添加成功',
              type: 'success'
            });
            this.loadData();
          }).catch(() => loading.close());
        }
      },

      /**
       * 删除
       */
      deleteProduct (obj) {
        this.$confirm('确认删除该商品吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const loading = this.$loading();
          deleteProduct(obj.id).then(result => {
            loading.close();
            if (result > 0) {
              this.$message({
                message: '删除成功',
                type: 'success'
              });
              this.loadData();
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },

      /**
       * 上传成功后显示图片
       * @param res 响应
       */
      handleAvatarSuccess (res) {
        this.formData.icon = res.file.url;
      },

      /**
       * 图片上传之前验证格式,大小
       */
      beforeAvatarUpload (file) {
        const isJPG = file.type === 'image/jpeg' || 'image/jpg' || 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
      findProductType (value) {
        const productType = _find_(this.productType, {value});
        return productType && productType.label;
      },
      findProductStatus (value) {
        const status = _find_(this.productStatus, {value});
        return status && status.label;
      },
      findSellType (value) {
        const status = _find_(this.sellType, {value});
        return status && status.label;
      },
      formatTimeLimit (value) {
        let retStr = '';
        if (value != '') {
          value.split('|').forEach(function (item) {
            let temp = item.split(',');
            if (retStr != '')
              retStr += '|';
            retStr += temp[0] + '小时' + temp[1] + '钻';
          });
        }
        return retStr;
      }
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .search {
    margin-top: 10px;
    margin-left: 20px;
    .input {
      width: 100%;
    }
  }

  .update {
    margin-top: 10px;
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 100px;
      height: 100px;
      line-height: 100px;
      text-align: center;
    }
    .avatar {
      width: 100%;
      height: 100%;
      display: block;
    }
    .img-box {
      width: 100px;
      height: 100px;
    }

    .form-item__full-width .el-select,
    .form-item__full-width .el-input-number {
      width: 100%;
    }
  }
</style>
<style>
  .priceInput {
    display: inline-block;
    width: 142px !important;
  }
</style>
<style scoped>
  .el-upload__demo {
    line-height: 1;
  }

  img {
    vertical-align: middle !important;
  }

  /*这里是elementUI组件自动生成的元素*/

  .el-upload-dragger {
    width: 100px;
    height: 100px;
  }

  .el-input-number .el-input__inner {
    text-align: left;
  }

  .product-table-expand {
    font-size: 0;
  }

  .product-table-expand label {
    width: 90px;
    color: #99a9bf;
  }

  .product-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>




// WEBPACK FOOTER //
// products.vue?0912b7c5